import { render, staticRenderFns } from "./BaseRadioButtonListItemCircle.vue?vue&type=template&id=6989cf05&scoped=true"
import script from "./BaseRadioButtonListItemCircle.vue?vue&type=script&lang=js"
export * from "./BaseRadioButtonListItemCircle.vue?vue&type=script&lang=js"
import style0 from "./BaseRadioButtonListItemCircle.vue?vue&type=style&index=0&id=6989cf05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6989cf05",
  null
  
)

export default component.exports